import React, { useMemo } from 'react'
import classnames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { setSidebarOpen } from '../store/slices/appSlice'
import Logo from '../components/Logo'

export default ({ pages, location, children }) => {
  const dispatch = useDispatch()
  const { sidebarOpen } = useSelector((state) => state.app)

  const toggleSidebar = () => {
    dispatch(setSidebarOpen(!sidebarOpen))
  }

  const currentPage = useMemo(
    () => _.find(pages, (page) => page?.url === location.pathname),
    [pages, location.pathname],
  )

  const showLogo = [
    '/',
    '/auth/login',
    '/auth/register',
    '/auth/reset-password',
    '/auth/login/step-2',
  ].includes(currentPage?.url)

  return (
    <header className={`main-header ${currentPage?.url === '/' ? 'mobile-header-home' : ''}`}>
      <div
        id="mobile-menu-trigger"
        className={classnames('mobile-menu-trigger', { open: sidebarOpen })}
        onClick={toggleSidebar}
      >
        <span />
        <span />
        <span />
        <span />
      </div>
      <div className="title-container">
        {showLogo ? <Logo /> : <span>{currentPage?.menuTitle}</span>}
      </div>
      {children}
    </header>
  )
}
